import styled from 'styled-components';
import { Dropdown } from 'shared-components';

export const FieldHint = styled.p`
  margin: 5px 0 0;
  color: #6b7280;
  font-size: 12px;
`;

// The shared Dropdown has no error state of its own; the outline matches an invalid Input.
export const ContactDropdown = styled(Dropdown)`
  &[aria-invalid='true'] {
    border: ${({ theme }) => theme.borders.error};
  }
`;
